import { RouteMap } from '~/lib/routeMap'
import { getMainLocaleCodes, getLocaleName } from '~/utils/localization'

export const getItems = () => {
  const mainLocalesCodes = getMainLocaleCodes()
  const localeOptions = mainLocalesCodes.map(localeCode => ({
    name: getLocaleName(localeCode),
    value: localeCode,
  }))

  return {
    primary: [
      { title: 'common:footer.primary.home', href: RouteMap['HOME'] },
      {
        title: 'common:footer.primary.howItWorks',
        href: RouteMap['HOW_DOES_IT_WORK'],
      },
      {
        title: 'common:footer.primary.aboutUs',
        href: {
          pathname: RouteMap['CONTENT'],
          query: {
            slug: 'about-us',
          },
        },
      },
      {
        title: 'common:generic.blog',
        href: RouteMap['BLOG'],
      },
      {
        title: 'common:footer.primary.jobs',
        url: 'https://jobs.ticketswap.com/',
      },
      {
        title: 'common:footer.primary.partners',
        href: RouteMap['PARTNERS'],
      },
      {
        title: 'common:footer.primary.affiliate',
        url: 'https://affiliate.ticketswap.com/',
        locales: ['en'],
      },
      {
        title: 'common:footer.primary.press',
        url: 'https://press.ticketswap.com/',
      },
    ],
    legal: [
      {
        title: 'common:footer.legal.conditions',
        href: {
          pathname: RouteMap['CONTENT'],
          query: {
            slug: 'conditions',
          },
        },
      },
      {
        title: 'common:footer.legal.privacy',
        href: {
          pathname: RouteMap['CONTENT'],
          query: {
            slug: 'privacy',
          },
        },
      },
      {
        title: 'common:footer.legal.responsibleDisclosure',
        href: {
          pathname: RouteMap['CONTENT'],
          query: {
            slug: 'responsible-disclosure',
          },
        },
      },
      {
        title: 'common:footer.legal.imprint',
        href: {
          pathname: RouteMap['CONTENT'],
          query: {
            slug: 'imprint',
          },
        },
        languages: ['de'],
      },
    ],
    social: [
      {
        title: 'Facebook',
        url: 'https://www.facebook.com/TicketSwap',
      },
      {
        title: 'Twitter',
        url: 'https://www.twitter.com/TicketSwap',
      },
      {
        title: 'Instagram',
        url: 'https://www.instagram.com/ticketswap',
      },
      {
        title: 'TikTok',
        url: 'https://www.tiktok.com/@ticketswap',
      },
    ],
    locales: localeOptions,
  }
}
